import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';

export interface TermsAndConditions {
  id: string;
  createdDate: string;
  text: string;
}

export interface TermsAndConditionsStatus {
  currentVersionId: string;
  acceptedVersionId: string | null;
  acceptedAt: string | null;
  acceptedCurrent: boolean;
}

/**
 * User-level terms and conditions API.
 * Acceptance is recorded on the user - it is not bound to any mortgage or protection case.
 */
@Injectable({ providedIn: 'root' })
export class TermsAndConditionsService {
  private readonly API_NAME = 'client';

  constructor(private apiService: ApiService) {}

  public getCurrentTermsAndConditions(): Observable<TermsAndConditions> {
    return this.apiService.get(this.API_NAME, 'termsAndConditions/current');
  }

  public getTermsAndConditionsStatus(): Observable<TermsAndConditionsStatus> {
    return this.apiService.get(this.API_NAME, 'termsAndConditions/status');
  }

  public acceptTermsAndConditions(termsAndConditionsId: string): Observable<any> {
    return this.apiService.post(this.API_NAME, 'termsAndConditions/accept', null, {
      params: { termsAndConditionsId }
    });
  }
}
